import { render } from "./EditCategoryBar.vue?vue&type=template&id=8f41d4e8"
import script from "./EditCategoryBar.vue?vue&type=script&lang=js"
export * from "./EditCategoryBar.vue?vue&type=script&lang=js"

import "./EditCategoryBar.vue?vue&type=style&index=0&id=8f41d4e8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__